import React from 'react';
import { withRouter } from 'react-router';
import Velocity from 'velocity-animate';

class ScrollToTop extends React.Component {
  componentDidMount() {
      // window.scrollTo(0, 0);
    Velocity(
      document.body,
      'scroll',
      {
        duration: 800,
        easing: 'ease-in-out',
        offset: 0,
      }
    );
  }

  render() {
    return null;
  }
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/components/ScrollToTop.js